<template>
  <v-container fill-height container--fluid >
      <v-row>
        <v-col cols="12">
            <v-breadcrumbs
            :items="breadCrumbsItems"
              divider=">"
              ></v-breadcrumbs>
        </v-col>
      </v-row>
      <summary-of-account :filterUsers="filterUser" userType="AM" />
  </v-container>
</template>
<script>
import userAPIs from '../User/userAPIs';
import SummaryOfAccount from '../DashboardComponents/summaryOfAccount'
import config from '@/config';

export default {
  name: 'AM_Spend_Revenue',
  components: {
    SummaryOfAccount
  },
  data() {
    return {
      breadCrumbsItems: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/am/dashboard'
        },
        {
          text: 'Spend Revenue',
          disabled: true,
          href: ''
        }
      ],
      filterUser: []
    }
  },
  computed: {
  },
  async mounted() {
    let response
    // Get all AM users
    response = await userAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
    if (response) {
      this.filterUser = response.users.map(user => {
        user.name = `${user.firstName} ${user.lastName}`
        return user
      })
      this.filterUser.unshift({id: '', name: 'All Team'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// spendRevenue.vue?7b9ae692